var service = function($rootScope) {
  var lookup = function(marketId) {
    if (!$rootScope.adminMarkets) { return; }
    return _.find($rootScope.adminMarkets, function(x) { return x['id'] == marketId });
  }

  return {
    lookup: lookup
  };
};
service.$inject = ['$rootScope'];

tiz.service('Market', service);
